const locale = document.getElementsByTagName('html')[0].getAttribute('lang')
export default {
    getLocale: function () {
        return locale;
    },
    getTranslation: function(collection, property) {
        if(! collection.translations) return collection[property]

        let translation = collection.translations.filter(function(trans) {
            
            return trans.column_name === property && 
                   trans.locale === locale
        })
        return (translation.length) ? translation[0].value : collection[property];
    },
    slugify: function(str){
        str = str.replace(/^\s+|\s+$/g, '');

        // Make the string lowercase
        str = str.toLowerCase();

        // Remove accents, swap ñ for n, etc
        var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
        var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        // Remove invalid chars
        str = str.replace(/[^a-z0-9 -]/g, '')
        // Collapse whitespace and replace by -
            .replace(/\s+/g, '-')
            // Collapse dashes
            .replace(/-+/g, '-');

        return str;
    }
}




// WEBPACK FOOTER //
// ./resources/assets/js/site/helpers.js